module.exports = __webpack_public_path__ + "static/media/PATS_3-480w.85ca373a.webp";